import { h, Component, } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {Form, Button, I18n, FormEntry, Container } from 'components/elements' 
import {connect} from 'react-redux'
import {AccountActions, SessionActions} from 'actions'
import style from './style.less'
import _ from 'lodash'

@Form
@connect((state)=> state)
export default class ConfirmAuthenticators extends WidgetComponent {
    constructor(){
        super()
        this.state = {
            mobilePhoneError: '',
            emailError: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(values){
        this.componentWillSubmit().then((r)=>{
            if(values.mobilePhone){
                AccountActions.authenticatorOwnershipTransfer({
                    token: values.mobilePhone
                }).then((res)=>{
                    SessionActions.set({
                        ...this.props.session,
                        messages:[]
                    })
                    this.setState({
                        mobilePhoneError: ''
                    })
                    this.props.onSubmit && this.props.onSubmit()
                }).catch((e)=>{
                    this.setState({
                        mobilePhoneError: 'Mobile Phone Token Invalid'
                    })
                })
            }
            if(values.email){
                AccountActions.authenticatorOwnershipTransfer({
                    token: values.email
                }).then((res)=>{
                    SessionActions.set({
                        ...this.props.session,
                        messages:[]
                    })
                    this.setState({
                        emailError: ''
                    })
                    this.props.onSubmit && this.props.onSubmit()
                }).catch((e)=>{
                    this.setState({
                        emailError: 'Email Token Invalid'
                    })
                })
            }
        })
    }

    render() {
        const {Form, InputDark} = this.props;
        return (
            <div class={style.confirmAuthenticators}>
                <div class={style.form}>
                    <Container radius={false}>
                        <Form onSubmit={this.handleSubmit}>
                            <h3>Confirm Ownership</h3>
                            {this.props.confirmAuthenticators.map((authenticator)=>(
                                <FormEntry style={{maxWidth: '6em', margin: '0px auto'}}>
                                    <InputDark 
                                        required={true} 
                                        name={authenticator} 
                                        id={`authenticator-${authenticator}`} 
                                        question={I18n.t('Authenticator')} 
                                        type='text'  
                                    />
                                </FormEntry>
                            ))}
                            {this.state.mobilePhoneError &&
                                <div>
                                    {this.state.mobilePhoneError}
                                </div>
                            }
                            {this.state.emailError &&
                                <div>
                                    {this.state.emailError}
                                </div>
                            }
                            <br />
                            <br />
                            <Button>Submit</Button>
                        </Form>
                    </Container>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/partials/ConfirmAuthenticator/index.js